var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "#FEF2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4413_4423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 58C44.7739 58 49.3523 56.1036 52.7279 52.7279C56.1036 49.3523 58 44.7739 58 40C58 35.2261 56.1036 30.6477 52.7279 27.2721C49.3523 23.8964 44.7739 22 40 22C35.2261 22 30.6477 23.8964 27.2721 27.2721C23.8964 30.6477 22 35.2261 22 40C22 44.7739 23.8964 49.3523 27.2721 52.7279C30.6477 56.1036 35.2261 58 40 58ZM40 31C40.9352 31 41.6875 31.7523 41.6875 32.6875V40.5625C41.6875 41.4977 40.9352 42.25 40 42.25C39.0648 42.25 38.3125 41.4977 38.3125 40.5625V32.6875C38.3125 31.7523 39.0648 31 40 31ZM37.75 46.75C37.75 46.1533 37.9871 45.581 38.409 45.159C38.831 44.7371 39.4033 44.5 40 44.5C40.5967 44.5 41.169 44.7371 41.591 45.159C42.0129 45.581 42.25 46.1533 42.25 46.75C42.25 47.3467 42.0129 47.919 41.591 48.341C41.169 48.7629 40.5967 49 40 49C39.4033 49 38.831 48.7629 38.409 48.341C37.9871 47.919 37.75 47.3467 37.75 46.75Z",
    fill: "#EF4444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4413_4423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaildIcon);
export default __webpack_public_path__ + "static/media/faild-icon.bbdea50f7897f9abece6547772c4c8db.svg";
export { ForwardRef as ReactComponent };